import { AxiosResponse } from "axios";
import { apiCoreV3 } from "../apiCoreV3";

export type TSalesCompanyType = {
  label: string;
  value: string;
};

const apiListSalesCompanyTypes = async () => {
  const res: AxiosResponse<TSalesCompanyType[]> = await apiCoreV3.get(
    `/sales-company/types`
  );

  return res.data;
};

export { apiListSalesCompanyTypes };
